import React, { useMemo } from 'react';
import { Table, TableHead, TableBody, TableRow, TableCell } from '@this/shared/ui/data_displays/table';

// 当日キャンセル受付緩和ルール（鉄道・国内航空券共通）の期限テーブル＋プレミアムオプション注釈
// 罫線グリッドの見た目は372由来の既存ガイド表示を維持するため style で指定している
const SameDayCancelRuleTable: React.FC = () => {
  const styles = useMemo(() => getStyles(), []);
  return (
    <>
      <p style={styles.sectionLabel}>▼キャンセル受付期限について</p>
      <Table style={styles.table}>
        <TableHead>
          <TableRow>
            <TableCell th style={styles.cell}>
              出発時刻
            </TableCell>
            <TableCell th style={styles.cell}>
              キャンセル依頼期限
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell style={styles.cell}>～10:59</TableCell>
            <TableCell style={styles.cell}>前営業日※ 18:00まで</TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={styles.cell}>11:00～20:00</TableCell>
            <TableCell style={styles.cell}>出発時刻の2時間前まで</TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={styles.cell}>20:01～</TableCell>
            <TableCell style={styles.cell}>当日 18:00まで</TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <p style={styles.noteHeading}>※「前営業日」はプレミアムオプションの有無によって異なります</p>
      <p style={styles.noteLine}>・あり：土日祝を含む前日 ／ なし：直前の平日（土日祝除く）</p>
      <p style={styles.noteExample}>　例）月曜日出発の場合 → あり：日曜日 18:00／なし：金曜日 18:00</p>
    </>
  );
};

const getStyles = () => {
  const cell: React.CSSProperties = {
    border: '1px solid #999',
    padding: '6px 10px',
    verticalAlign: 'top',
    fontSize: 'inherit',
    fontFamily: 'inherit',
    lineHeight: 'inherit',
    letterSpacing: 'inherit',
    backgroundColor: 'transparent'
  };
  return {
    sectionLabel: {
      fontWeight: 'bold' as const,
      marginBottom: '6px'
    },
    table: {
      borderCollapse: 'collapse' as const,
      marginBottom: '12px',
      width: '100%'
    },
    cell,
    noteHeading: {
      fontSize: 13,
      marginBottom: '6px'
    },
    noteLine: {
      fontSize: 13,
      marginBottom: '4px'
    },
    noteExample: {
      fontSize: 13,
      marginBottom: '20px'
    }
  };
};

export default SameDayCancelRuleTable;
